module.exports = __webpack_public_path__ + "img/book_badge.47e80e29.png";